module.exports = __webpack_public_path__ + "tbc.3b2157c4.png";